import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    /**
     * Constructor.
     * @param authService
     * @param router
     */
    constructor(private authService: AuthService, private router: Router) {
    }


    /**
     * Checks.
     * @param route
     * @param state
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkToken(state.url);
    }

    /**
     * Checks.
     * @private
     */
    private checkToken(aTargetUrl): boolean | Observable<boolean> {

        // OK, token active
        if (this.authService.getToken() != null) {
            return true;
        }

        // NO token
        this.router.navigate(['/login']);
        return false;
    }

}
